import {ReactElement, useEffect} from "react"
import {observer} from "mobx-react-lite"
import dayjs from "dayjs"
import {Button, Checkbox, Input, notification, Space, Switch, Table, Tooltip} from "antd"
import {t} from "@ui/common/intl"
import {useStore} from "@ui/stores"
import {Adapter as AdapterStore} from "@ui/stores/service/adapter"
import {MenuItemProps} from "../menu"
import SwipePanel, {SwipePanelHeight} from "../common/SwipePanel"

const Adapter = ({isShow, close}: MenuItemProps): ReactElement => {
  const {adapter, movement} = useStore()
  const [notify, contextHolder] = notification.useNotification()

  useEffect(() => {
		if (adapter.closeWithError) {
      notify?.error({message: t("adapter.error.disconnect"), placement: 'topRight'})
		}
	}, [adapter.closeWithError])

  const parseData = () => {
    const dataSource: {key: number, name: string | ReactElement, value: string | ReactElement, selected: ReactElement, timestamp: number}[] = []
    let i = 0
    for (let key in adapter.data) {
      dataSource.push({
        key: i,
        name: t(`adapter.${adapter.data[key].name}.title`),
        value: AdapterStore.parseValue(adapter.data[key]).join(" "),
        selected: <Checkbox
          disabled={adapter.widgets.length >= AdapterStore.MAX_WIDGETS_COUNT && !adapter.widgets.includes(key)}
          onClick={() => adapter.toggleWidget(key)}
          checked={adapter.widgets.some(w => w === key)}
        />,
        timestamp: adapter.data[key].timestamp
      })
      i++
    }
    return dataSource
  }

  const handleConnect = () => {
    adapter.isConnected
      ? adapter.disconnect()
      : adapter.url
        ? adapter.connect()
        : notify?.error({message: t("adapter.url.empty.error"), placement: 'topRight'})
  }

  return (
    <>
      {isShow && <SwipePanel
          onClose={close}
          onSwipe={close}
          className="adapter"
          height={SwipePanelHeight.FULL}
          header={
            <span>
              {t("adapter.window.title")}
              {adapter.isConnected &&
                <Tooltip title={t("adapter.switch.use.adapter.tooltip")}>
                  <Switch className="use-adapter-switch" checked={movement.useAdapter} onChange={movement.switchAdapter.bind(movement)} />
                </Tooltip>
              }
            </span>
          }
      >
        <>
        {contextHolder}
            <div className="body">
              <Space.Compact style={{width: '100%'}}>
                <Input value={adapter.url} onChange={(e) => adapter.setUrl(e.target.value)}/>
                <Button type="primary" onClick={handleConnect}>
                  {t(`button.${adapter.isConnected ? "dis" : ""}connect`)}
                </Button>
              </Space.Compact>
              <Table
                pagination={false}
                size="small"
                dataSource={parseData()}
                rowClassName={(data, i) =>
                  data.timestamp && dayjs().diff(dayjs(data.timestamp), "seconds") > 15 ? "overdue" : ""
                }
                columns={[
                  {title: t("adapter.table.header.name"), dataIndex: "name", key: "name", width: "100px", align: "left"},
                  {title: t("adapter.table.header.value"), dataIndex: "value", key: "value", align: "center"},
                  {title: t("adapter.table.header.selected"), dataIndex: "selected", key: "selected", align: "right"}
                ]}
              />
            </div>
          </>
        </SwipePanel>
      }
    </>
  )
}

export default observer(Adapter)
